class LoadingGlobal {
	constructor() {
		this.state = [];
		this.isActive = true;
		this.$loading = document.querySelector('[loading-global]');
	}

	show() {
		if (this.isActive) {
			this.state.push('');
			this.updateDisplay();
		}
	}

	hide() {
		if (this.isActive) {
			this.state.pop();
			this.updateDisplay();
		}
	}

	updateDisplay() {
		if (this.state.length) {
			this.$loading.hidden = false;
		} else {
			this.$loading.hidden = true;
		}
	}

	setActive(isActive) {
		this.isActive = isActive;
		if (!isActive) {
			this.$loading.hidden = true;
			this.state = [];
		}
	}
}

export default new LoadingGlobal();



// WEBPACK FOOTER //
// ./client/src/core/lib/loading-global.js